import React, { useState, useRef, useEffect } from 'react'
import { ClaimProvider, useClaimData, useUpdateClaimData } from '../claimProvider'
import {
    HeroSection,
    WhatIsIrresponsibleLending,
    WhyChooseUs,
    SecurePortal,
    FaqSection,
    ProcessSection,
} from '../components/irresponsibleLendingLanding'
import styles from './irresponsibleLendingLanding.module.scss'
import { uploadDataToServer } from '../helpers'
import { uploadILDataToServer } from '../helpers/uploadFileIL'
import { Loading } from 'notiflix'
import { Report } from 'notiflix'
interface FormData {
    [key: string]: string
}

export const IrresponsibleLendingLanding = () => {
    const [formData, setFormData] = useState<FormData>({})
    const [currentSection, setCurrentSection] = useState<string>('address')
    const [showExpandedForm, setShowExpandedForm] = useState<boolean>(false)
    const [isTransitioningBack, setIsTransitioningBack] = useState<boolean>(false)
    const [isAnimatingIn, setIsAnimatingIn] = useState<boolean>(false)
    const [isFadingOutConfirm, setIsFadingOutConfirm] = useState<boolean>(false)
    const formRef = useRef<HTMLDivElement>(null)

    const claimData = useClaimData()
    const updateClaim = useUpdateClaimData()

    useEffect(() => {
        console.log('CLAIM DATA CHANGED.... ', claimData)
    }, [claimData])

    const saveValueFunction = (data: { field: string; value: string }) => {
        // console.log('DATA TO SAVE: ', data)
        const updatedData = {
            ...claimData,
            [data.field]: data.value,
            type: 'webform_IRRESPONSIBLE_BOSH',
        }
        updateClaim(updatedData)
        return { success: true, error: '' }
    }

    const assignGroup = (group: string) => {
        setCurrentSection(group)

        // When reaching confirm or signature steps, expand form and hide hero content
        if (group === 'confirm' || group === 'signature' || group === 'openBankingLink') {
            setShowExpandedForm(true)
            setIsTransitioningBack(false)
            setIsAnimatingIn(false)
            setIsFadingOutConfirm(false)
        } else {
            // When leaving confirm/signature steps, reset to original layout
            if (showExpandedForm) {
                // Phase 1: Fade out confirm step quickly
                setIsFadingOutConfirm(true)

                // Phase 2: After confirm fades out, change layout and prepare for slide-in
                setTimeout(() => {
                    setShowExpandedForm(false)
                    setIsFadingOutConfirm(false)
                    setIsAnimatingIn(true)
                }, 200) // Fast confirm fade out

                // Phase 3: Complete the slide-in animation
                setTimeout(() => {
                    setIsAnimatingIn(false)
                }, 800) // Allow time for slide-in animation
            }
        }
    }

    const asyncAssignGroup = async (group: string) => {
        try {
            if (group === 'signature') {
                const uploaded = await uploadILDataToServer(claimData)

                if (uploaded.success) {
                    const responseData = uploaded.responseData
                    const updatedData = {
                        ...claimData,
                        ...responseData,
                        cfaUrl: responseData.cfaUrl,
                        leadOrigin: 'webform_IRRESPONSIBLE_BOSH',
                        // client_id: newClientId,
                        // client_id: newClientId,
                    }
                    updateClaim(updatedData)
                    setCurrentSection(group)
                } else {
                    throw new Error('Failed to upload data')
                }
            }
        } catch (error: any) {
            console.error('Failed to upload claim data:', error)
            Report.failure('Error', error.message, 'OK')
            return
        }
    }

    const scrollToForm = () => {
        // formRef.current?.scrollIntoView({
        //     behavior: 'smooth',
        //     block: 'start',
        // })
    }

    return (
        <div className={styles.landingPage}>
            {/* Hero Section */}
            <HeroSection
                formData={formData}
                currentSection={currentSection}
                showExpandedForm={showExpandedForm}
                isTransitioningBack={isTransitioningBack}
                isAnimatingIn={isAnimatingIn}
                isFadingOutConfirm={isFadingOutConfirm}
                formRef={formRef}
                saveValueFunction={saveValueFunction}
                assignGroup={assignGroup}
                asyncAssignGroup={asyncAssignGroup}
            />

            {/* Information Sections */}
            {!showExpandedForm && (
                <>
                    <ProcessSection onScrollToForm={scrollToForm} />
                    <SecurePortal onScrollToForm={scrollToForm} />
                    <WhyChooseUs onScrollToForm={scrollToForm} />
                    <WhatIsIrresponsibleLending onScrollToForm={scrollToForm} />
                    <FaqSection onScrollToForm={scrollToForm} />
                </>
            )}
        </div>
    )
}

export default IrresponsibleLendingLanding
